import { Button } from 'antd';
import React, { useEffect, useState } from 'react';

function Time() {
    let [datetime, setDatetime] = useState('00:00 00.00.0000')
    useEffect(() => {
        const interval = setInterval(() => {
            let time = new Date()
            setDatetime(time.toLocaleString('ru-RU', { hour12: false }))
        }, 1000)
        return () => clearInterval(interval)
    }, [])
    return (
        <div className='toptime'>
            <Button style={{ fontSize: '18px', fontWeight: 'bold' }}>{datetime}</Button>
        </div>
    );
}

export default Time;
